import { SearchState } from '@/domain/search/types'
import {
  isNonEmptyArray,
  isNonEmptyObject,
  isNonEmptyString,
  isString
} from '@/utils/checks'

export const getMatchedSearchTerm = (
  searchState: SearchState['refinementList'] | SearchState
): string => {
  if (isNonEmptyObject(searchState)) {
    const searchTerm = Object.keys(searchState).find((key) =>
      key !== 'locations' ? searchState[key] : ''
    )
    if (!isNonEmptyString(searchTerm)) {
      return ''
    }
    if (isString(searchState[searchTerm])) {
      return searchState[searchTerm]
    }
    if (isNonEmptyArray(searchState[searchTerm])) {
      return (searchState[searchTerm][0] as string) || ''
    }
  }
  return ''
}
